/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Template_Position_VInputs */

const en_event_template_position_v = /** @type {(inputs: Event_Template_Position_VInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`V:`)
};

const fr_event_template_position_v = /** @type {(inputs: Event_Template_Position_VInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`V:`)
};

const de_event_template_position_v = /** @type {(inputs: Event_Template_Position_VInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`V:`)
};

const it_event_template_position_v = /** @type {(inputs: Event_Template_Position_VInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`V:`)
};

const ru_event_template_position_v = /** @type {(inputs: Event_Template_Position_VInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В:`)
};

const es_event_template_position_v = /** @type {(inputs: Event_Template_Position_VInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`V:`)
};

const zh_cn2_event_template_position_v = /** @type {(inputs: Event_Template_Position_VInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`V：`)
};

const ja_event_template_position_v = /** @type {(inputs: Event_Template_Position_VInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`V:`)
};

const hi_event_template_position_v = /** @type {(inputs: Event_Template_Position_VInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वी:`)
};

const pt_pt2_event_template_position_v = /** @type {(inputs: Event_Template_Position_VInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`V:`)
};

/**
* | output |
* | --- |
* | "V:" |
*
* @param {Event_Template_Position_VInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_template_position_v = /** @type {((inputs?: Event_Template_Position_VInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Template_Position_VInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_template_position_v(inputs)
	if (locale === "de") return de_event_template_position_v(inputs)
	if (locale === "it") return it_event_template_position_v(inputs)
	if (locale === "ru") return ru_event_template_position_v(inputs)
	if (locale === "es") return es_event_template_position_v(inputs)
	if (locale === "zh-CN") return zh_cn2_event_template_position_v(inputs)
	if (locale === "ja") return ja_event_template_position_v(inputs)
	if (locale === "hi") return hi_event_template_position_v(inputs)
	if (locale === "pt-PT") return pt_pt2_event_template_position_v(inputs)
	return en_event_template_position_v(inputs)
});